import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
  namespaced: true,
  state: {
    items: [],
    itemsMeta: [],
    itemsOption: [],
    itemsDetail: [],
    itemsLoading: true,
  },
  getters,
  mutations,
  actions,
};
